import {DEMO_COMPANY_ID} from "./constants";

export const companyIdForRouting = (
    sourceCompanyId: string | null | undefined,
    activeCompanyId: string | undefined,
): string | null => {
    const src = typeof sourceCompanyId === "string" ? sourceCompanyId : null;

    if (activeCompanyId === DEMO_COMPANY_ID) return DEMO_COMPANY_ID;

    return src;
};

export default companyIdForRouting;
